import React, { useEffect, useState } from "react";
import News from "../components/home/News";
import { Link } from "react-router-dom";
import { Fade } from "react-reveal";
import AuctionCard from "../components/shared/AuctionCard";
import { useContent } from "../hooks/useContent";
import { useTranslation } from "react-i18next";
import EventsSlider from "../components/shared/EventsSlider";

import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import {Content} from './Vision';
const Home = () => {
    // ----------- hooks ------------
    const { t, i18n } = useTranslation();
    const {
        projects,
        fetchProjects,
        events,
        fetchEvents,
        partners,
        fetchPartners,
        fetchNews
    } = useContent();
    const [selectedPartner, setSelectedPartner] = useState({});

    // ----------- side effect ------------
    useEffect(() => {
        fetchProjects();
        fetchEvents();
        fetchPartners();
        fetchNews();
    }, [i18n.language]);

    useEffect(() => {
      setSelectedPartner(partners[-1])
    }, [partners]);
    return (
        <>
        <Header />
        <div style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
            <Content />
            {partners.length > 0 && (
                <div className="my-10 mx-[100px]">
                    <h1 className="py-5 font-semibold text-4xl text-black">
                        {t("Arcelia's arms")}
                    </h1>
                    <div className="py-5 overflow-hidden flex flex-col gap-10">
                        <div className="branches-card flex flex-col md:flex-row gap-10">
                            {partners.slice(0, 4).map((item, index) => (
                                <Fade key={index} bottom>
                                    <div
                                        onClick={() => setSelectedPartner(item)}
                                        className={`w-60 h-60 p-5 flex items-center justify-center rounded-xl cursor-pointer ${
                                            item?.id === selectedPartner?.id
                                                ? "bg-hoverGray"
                                                : " opacity-50"
                                        }`}
                                    >
                                        <img
                                            className="h-48 w-48 object-contain"
                                            src={item?.image}
                                            alt="branches"
                                        />
                                    </div>
                                </Fade>
                            ))}
                        </div>
                    </div>
                    <div className="w-full text-center">
                        <h1 className="font-semibold text-2xl text-purple my-4">
                            {selectedPartner?.title}
                        </h1>
                        <p className="text-lg font-medium">
                            {selectedPartner?.text}
                        </p>
                    </div>
                </div>
            )}
            <div className="bg-[#f4f4f4]">

            {projects.length > 0 && (
                <div className={"auction relative pt-14 p-5 md:p-0 md:pt-20 "}>
                    <Fade bottom>
                        <div className="flex flex-row items-center justify-between pb-10">
                            <h1 className="font-semibold text-4xl text-black">
                                {t("Recent projects")}
                            </h1>
                            <Link to="/projects">
                                <p className="font-semibold text-2xl text-purple cursor-pointer">
                                    {t("More")}
                                </p>
                            </Link>
                        </div>
                    </Fade>
                </div>
            )}
            </div>
            <div className="bg-[#f4f4f4] pb-16">
            {projects.length > 0 && (
                <AuctionCard item={projects[0]} special={true} />
            )}
            </div>
            {events.length > 0 && (
                <div className="bg-bgGray md:w-4/6 py-20 px-5 mx-auto">
                    <Fade right>
                        <h1 className="font-semibold text-4xl text-black">
                            {t("Recent events")}
                        </h1>
                    </Fade>
                    <div className="py-10 flex flex-col md:flex-row items-center gap-20">
                        <Fade right>
                            <div className="md:w-96 w-72 rounded-xl overflow-hidden">
                                <EventsSlider
                                    images={[
                                        events[0].special_image,
                                        events[0].image2,
                                        events[0].image3,
                                        events[0].image4,
                                        events[0].image5,
                                        events[0].image6,
                                    ]}
                                />
                            </div>
                        </Fade>
                        <Fade left>
                            <div className="md:w-1/2">
                                <p className="text-lightGray font-medium">
                                    {events[0].date}
                                </p>

                                <h1 className="font-semibold text-2xl text-purple">
                                    {events[0].content}
                                    {events[0].content}
                                </h1>
                                <p className="text-lg font-medium">
                                    {events[0].special_content}
                                </p>
                                <br />
                                <Link to={`/${4}`}>
                                    <p className="text-purple font-semibold hover:text-lightGray">
                                        {t("More")}
                                    </p>
                                </Link>
                            </div>
                        </Fade>
                    </div>
                </div>
            )}
          
            <News />
        </div>
        <Footer />
        </>
    );
};

export default Home;
